import { Inject, Injectable } from '@angular/core'
import { DOCUMENT } from '@angular/common'

@Injectable({
	providedIn: 'root',
})
export class JsonLdService {
	private readonly elementId = 'json-ld-schema'

	constructor(@Inject(DOCUMENT) private document: Document) {}

	insertSchema(schema: object): void {
		this.removeSchema()
		const script = this.document.createElement('script')
		script.type = 'application/ld+json'
		script.id = this.elementId
		script.text = JSON.stringify(schema)
		this.document.head.appendChild(script)
	}

	removeSchema(): void {
		const existing = this.document.getElementById(this.elementId)
		if (existing) {
			existing.remove()
		}
	}
}
